import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 150 150">
    {props.children}
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m26.7 79 27-15.6.1-24-27.1 15.9V79ZM4.4 102.5 74.8 62l70.7 40.7-70.4 40.6-70.7-40.8Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.77 6.77"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M4.6 109 75 68.5l70.7 40.8-70.3 40.4L4.6 109Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m44.3 121 59.6-34.7.2-57.1-23.7-9.8-36.1 45V121Z"
    />
    <path fill="#fff" d="M48.4 88.2h-.1L48 88V30.9c0-.1 0-.2.2-.2L99.9 0h.2l.2.2-.2 57.6s0 .2-.2.2L48.5 88.2h-.1Z" />
    <path d="m100 .3-.2 57.5L48.4 88V30.9L100 .3m0-.6-.3.1-51.6 30.6-.2.5v57a.5.5 0 0 0 .5.6h.2l51.5-30.3.2-.4.2-57.6-.3-.4h-.2Z" />
    <path fill="#fff" d="m48.4 88 51.4-30.2.2-57.5-51.6 30.6v57Z" />
    <path fill="#F4EEE6" d="m48.4 88 51.4-30.2.2-57.5-51.6 30.6v57Zm6-53.7L94 10.8l-.2 43.5-39.4 23.2V34.3Z" />
    <path fill="#fff" d="m44.3 121 59.6-34.7.2-57.1-25.3 45.4-34.5-10.3V121Z" />
    <path fill="#F4EEE6" d="M44.3 118.4v2.6L104 86 73 73l-28.8 45.4Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m44.3 121 59.6-34.7.2-57.1-25.3 45.4-34.5-10.3V121Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m44.3 121 59.6-34.7h.2l-26.3-18L44.3 121Zm46.4-93.7 21-12V8.4l-21 12.2v6.6Z"
    />
    <path fill="#F4EEE6" d="M85.8 46.8 64 59.4V40.7l21.9-12.6v18.7Z" />
    <path
      fill="#fff"
      d="M69 45c.8-1 1.8-.6 2.1.6.3 1.2-.2 2.8-1.1 3.7-1 .9-2 .6-2.2-.6-.3-1.2.2-2.9 1.1-3.8Zm5.5-3.4c1-.9 2-.6 2.2.6.3 1.2-.2 2.9-1.1 3.7-1 .9-2 .6-2.2-.6-.3-1.2.2-2.8 1.1-3.7Zm5.6-3.2c1-.8 2-.6 2.2.6.3 1.2-.2 2.9-1.1 3.8s-2 .5-2.2-.6c-.3-1.3.2-3 1.1-3.8Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="m115.6 101.4-7.3 4 8 4.3 7.4-4-8-4.3Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="m105 106.6-16.3 8.8L97 120l16.4-8.9-8.4-4.5ZM89.7 120l-16.5 9.3"
    />
  </svg>
);
